import { MaterialCategoryDTO } from '@scip/api';

export class CategoryUtils {
  /**
   * check for id
   * @returns always true, doesnt matter what
   */
  static checkForCategoryId(materialCategories: MaterialCategoryDTO[], id: string): boolean {
    let isId = false;
    if (materialCategories && materialCategories.length) {
      isId = materialCategories.some((item) => item.identifier === id);
    }
    return isId;
  }
  /**
   * Checks whether the selected categories and initial categories differ
   * @returns true if the categories have changed
   */
  static selectionChanged(selectedCategories: { id?: number }[], initialCategories: { id?: number }[]): boolean {
    const initialCategoriesIds = initialCategories.map(({ id }) => id);
    const selectedCategoriesIds = selectedCategories.map(({ id }) => id);
    const delta = selectedCategoriesIds.filter((id) => !initialCategoriesIds.includes(id));
    const delta2 = initialCategoriesIds.filter((id) => !selectedCategoriesIds.includes(id));
    // Delta contains ids that are not contained in the other list, respectively. Categories have changed if the one of the deltas is not empty
    return delta.length !== 0 || delta2.length !== 0;
  }
}
